import { queryPremiumRateForMCI as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForMCI as calculateRiderPremium } from 'core/service/rider/premium-calculation'
import { queryTaxRateForMCI as queryTaxRate } from 'core/service/rider/query-tax-rate'
import _ from 'lodash'

// get plancode with custom logic
export const getRiderPlanCode = (rider, insureAge) => {
  const planCode = _.get(rider, 'selectedPlan.planCode', '')
  const age = insureAge.unit !== 'year' ? '0' : insureAge.value.toString()
  switch (planCode) {
    case 'MCI1': {
      return age <= 10 ? 'MCI1J' : 'MCI1S'
    }
    case 'MCI2': {
      return age <= 10 ? 'MCI2J' : 'MCI2S'
    }
    default:
      return planCode
  }
}

export default {
  calculateRiderPremium,
  queryPremiumRate,
  queryTaxRate,
  getRiderPlanCode,
}
